import {
  fetchFilterData,
  fetchCoverageList,
  fetchTotalSummary,
  fetchTransition
} from '@/api/savings-plans/coverage';
import { isFutureMonth } from '@/util/dateTimeUtils';



const getFilterData = (context, payload) => {
  context.commit('SET_IS_FILTER_DATA_LOADING', true);
  fetchFilterData(payload).then((response) => {
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    context.commit('FILTER_DATA_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_FILTER_DATA_LOADING', false);
    console.error(error);
  });
};


const getCoverageList = (context, payload) => {
  context.commit('SET_IS_COVERAGE_LIST_LOADING', true);
  fetchCoverageList(payload).then((response) => {
    context.commit('SET_IS_COVERAGE_LIST_LOADING', false);
    context.commit('COVERAGE_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_COVERAGE_LIST_LOADING', false);
    console.error(error);
  });
};

const getTotalSummary = (context, payload) => {
  context.commit('SET_IS_TOTAL_SUMMARY_LOADING', true);
  fetchTotalSummary(payload).then((response) => {
    context.commit('SET_IS_TOTAL_SUMMARY_LOADING', false);
    context.commit('TOTAL_SUMMARY_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_TOTAL_SUMMARY_LOADING', false);
    console.error(error);
  });
};

const getTransition = (context, payload) => {
  context.commit('SET_IS_TRANSITION_LOADING', true);
  fetchTransition(payload).then((response) => {
    context.commit('SET_IS_TRANSITION_LOADING', false);
    context.commit('TRANSITION_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_TRANSITION_LOADING', false);
    console.error(error);
  });
};


const selectedMonthToDate = (context, payload) => {
  context.commit('SET_ACTIVE_MONTH', payload);
};

const setDisplayedWarningBanner = (context, tabName) => {
  context.commit('SET_DISPLAYED_WARNING_BANNER', tabName);
}

const setSelectedViewByOption = (context, selectedViewBy) => {
  context.commit('SET_SELECTED_VIEW_BY_OPTION', selectedViewBy);
}

const setSelectedVendor = (context, selectedVendor) => {
  context.commit('SET_SELECTED_VENDOR', selectedVendor);
}

export default {
  getFilterData,
  getCoverageList,
  getTotalSummary,
  getTransition,
  setDisplayedWarningBanner,
  selectedMonthToDate,
  setSelectedViewByOption,
  setSelectedVendor
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/coverage/actions.js